'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from '@/i18n/navigation';
import imgTestimonialAvatar1 from '@/public/images/partner/testimonial-avatar-1.png';
import imgTestimonialAvatar2 from '@/public/images/partner/testimonial-avatar-2.png';
import imgTestimonialAvatar3 from '@/public/images/partner/testimonial-avatar-3.png';
import imgTestimonialCard1 from '@/public/images/partner/testimonial-card-1.png';
import imgTestimonialCard2 from '@/public/images/partner/testimonial-card-2.png';
import imgTestimonialCard3 from '@/public/images/partner/testimonial-card-3.png';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
export default function TestimonialsSection() {
  const $ = _c(54);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("partner.testimonials.testimonial1.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("partner.testimonials.testimonial1.quote");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = {
      title: t0,
      quote: t1,
      creator: "Oliver Fei",
      handle: "developer of CadenzaVR",
      image: imgTestimonialCard1,
      avatar: imgTestimonialAvatar1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t) {
    t3 = t("partner.testimonials.testimonial2.title");
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("partner.testimonials.testimonial2.quote");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = {
      title: t3,
      quote: t4,
      creator: "Georgy Molodtsov",
      handle: "Creative Producer of Frustrain",
      image: imgTestimonialCard2,
      avatar: imgTestimonialAvatar2
    };
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("partner.testimonials.testimonial3.title");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("partner.testimonials.testimonial3.quote");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = {
      title: t6,
      quote: t7,
      creator: "Peter Adams (A Number From the Ghost)",
      handle: "Creator of to the Limbs",
      image: imgTestimonialCard3,
      avatar: imgTestimonialAvatar3
    };
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t5 || $[23] !== t8) {
    t9 = [t2, t5, t8];
    $[21] = t2;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const testimonials = t9;
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      opacity: 0,
      y: 20
    };
    t11 = {
      opacity: 1,
      y: 0
    };
    t12 = {
      once: true,
      amount: 0.2
    };
    t13 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t10 = $[25];
    t11 = $[26];
    t12 = $[27];
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("partner.testimonials.title");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14) {
    t15 = <h2 className="text-[28px] leading-[30px] font-extrabold tracking-[0.15px] text-white md:text-[38px] md:leading-10">{t14}</h2>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("partner.testimonials.subtitle");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t16) {
    t17 = <p className="text-vive-primary-20 text-sm text-[16px] leading-[26px] tracking-[0.25px] md:text-base md:leading-8">{t16}</p>;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t15 || $[38] !== t17) {
    t18 = <motion.div initial={t10} whileInView={t11} viewport={t12} transition={t13} className="flex flex-col items-center gap-3 text-center md:gap-4">{t15}{t17}</motion.div>;
    $[37] = t15;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== testimonials) {
    t19 = <div className="flex w-full flex-col gap-4 md:grid md:grid-cols-2 md:gap-6 lg:grid-cols-3">{testimonials.map(_temp)}</div>;
    $[40] = testimonials;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  let t21;
  let t22;
  let t23;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      opacity: 0,
      y: 20
    };
    t21 = {
      opacity: 1,
      y: 0
    };
    t22 = {
      once: true,
      amount: 0.2
    };
    t23 = {
      duration: 0.8,
      ease: "easeOut"
    };
    $[42] = t20;
    $[43] = t21;
    $[44] = t22;
    $[45] = t23;
  } else {
    t20 = $[42];
    t21 = $[43];
    t22 = $[44];
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t) {
    t24 = t.rich("partner.testimonials.footer", {
      discord: t("partner.testimonials.footer-discord"),
      a: _temp2
    });
    $[46] = t;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t24) {
    t25 = <motion.div initial={t20} whileInView={t21} viewport={t22} transition={t23} className="text-vive-primary-30 flex flex-wrap items-center justify-center gap-1 text-center text-xs leading-[22px] tracking-[0.2px] md:text-sm">{t24}</motion.div>;
    $[48] = t24;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t18 || $[51] !== t19 || $[52] !== t25) {
    t26 = <section className="bg-background relative flex flex-col items-center justify-center px-4 py-12 md:px-8 md:py-20"><div className="flex w-full max-w-[1296px] flex-col gap-6 md:gap-16">{t18}{t19}{t25}</div></section>;
    $[50] = t18;
    $[51] = t19;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  return t26;
}
function _temp2(chunks) {
  return <Link href="https://discord.gg/viversecreators" className="text-vive-brand-50 hover:text-vive-brand-40 active:text-vive-brand-60 underline transition-colors">{chunks}</Link>;
}
function _temp(testimonial, index) {
  return <motion.div key={testimonial.title} initial={{
    opacity: 0,
    y: 36
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 1,
    ease: "easeOut",
    delay: index * 0.18
  }} className="flex flex-col justify-between gap-4 rounded-3xl border border-[rgba(181,194,213,0.1)] bg-linear-to-b from-[rgba(42,54,73,0.5)] to-[rgba(42,54,73,0.3)] px-4 py-6 md:gap-4 lg:gap-6 lg:px-6 lg:py-6"><div className="flex flex-col gap-4"><div className="h-[180px] w-full overflow-hidden rounded-[7px] md:h-44"><Image alt={testimonial.title} src={testimonial.image} width={400} height={347} className="h-full w-full object-cover" /></div><div className="flex flex-col gap-6"><h3 className="text-[18px] leading-8 font-semibold tracking-[0.2px] text-white">{testimonial.title}</h3><p className="text-vive-primary-20 text-base leading-6 font-normal tracking-[0.2px]">{testimonial.quote}</p></div></div><div className="flex flex-col gap-6 md:gap-8"><div className="flex items-center gap-2 md:gap-3"><div className="relative h-12 w-12 shrink-0 overflow-hidden rounded-full"><Image alt={testimonial.creator} src={testimonial.avatar} width={48} height={48} className="h-full w-full object-cover" /></div><div className="flex flex-col"><p className="text-[18px] leading-8 font-semibold tracking-[0.2px] text-white md:text-[16px] md:leading-6">{testimonial.creator}</p><p className="text-vive-primary-20 text-base leading-6 font-normal tracking-[0.2px]">{testimonial.handle}</p></div></div></div></motion.div>;
}